import { useEffect, useRef } from "react";

export function useResizeObserver(callback: (entry: DOMRectReadOnly) => void) {
  const ref = useRef(null);
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      callbackRef.current(entry.contentRect);
    });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  return ref;
}
